import { BaseDevice } from '@/profiles/base_device'
import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/nd63/list_icon.png'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_ND68 } from '../../light/light_effect_list'
import { generateArray } from '@/tool/utility'
import { nd63VKCodes_del } from '../keycode/vkeycode'
export class ND63Max extends BaseDevice {
  magneticAxis: boolean = true
  speedAllowValues: number[] = [4, 3, 2, 1, 0]
  lightAllowValues: number[] = generateArray(0, 5)

  minDelayTimer: number = 1
  maxDelayTimer: number = 60000

  square = getDeviceKeySquare(DevicePid.IROKNd63)
  name: string = 'ND63_Max'
  icon: string = list_icon
  width: number = 634
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_ND68
  inoperableKeys: KK[] = [0x41]
  fnDisableKeys: KK[] = [0x1, 0x7, 0xd, 0x13, 0x19, 0x1f, 0x25, 0x2b, 0x31, 0x37, 0x3d, 0x43, 0x49, 0x4f, 0x44, 0x4a, 0x9, 0xf, 0xb, 0x59, 0x5e, 0x5f, 0x52, 0x4d, 0x53, 0x65, 0x3b, 0x11]
  customLayout: CustomLayout = {
    0x4f: this.createSquare(2, 2, 74),
    0x2: this.createSquare(2, 2, 54),
    0x50: this.createSquare(2, 2, 60),
    0x3: this.createSquare(2, 2, 64),
    0x51: this.createSquare(2, 2, 91),
    0x4: this.createSquare(2, 2, 74),
    0x5: this.createSquare(2, 2, 48),
    0xb: this.createSquare(2, 2, 48),
    0x17: this.createSquare(2, 2, 48),
    0x11: this.createSquare(2, 2, 48),
    0x29: this.createSquare(2, 2, 256),
  }
  // rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = false
  vkcodes = nd63VKCodes_del
  adjustRTStabilization: number[] = [0, 25, 50, 75, 100]
  touchGuard = true
  rate: number[] = [8, 1]
}
